import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { TuiStringHandler, TuiContext } from '@taiga-ui/cdk';
import { TuiSizeL, TuiSizeS } from '@taiga-ui/core';
import { CommitteeService } from '@src/core/services';
import { CommitteeUI } from '@src/models';
import { BaseResizableComponent } from '@src/app/modules/base';

// TODO: необходимо научить компонент работать с ReactiveFormsModule (примеры - https://readerstacks.com/create-custom-form-control-in-angular-12/)
@Component({
  selector: 'app-committee-field',
  templateUrl: './committee-field.component.html',
  styleUrls: ['./committee-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommitteeFieldComponent extends BaseResizableComponent implements OnInit {
  private readonly committeeService = inject(CommitteeService);

  @Input() size: TuiSizeL | TuiSizeS = 'm';
  @Input() multiple: boolean = false;
  @Input() selectedIds: string[] = [];
  @Input() label?: string;
  @Input() disableSelect: string[] = [];
  @Output() selectedIdsChange: EventEmitter<string[]> = new EventEmitter();

  dropdownVisible: boolean = false;
  selectedCommittees?: CommitteeUI[] = [];
  committees?: CommitteeUI[];
  committeesTree?: CommitteeUI[];

  override ngOnInit(): void {
    super.ngOnInit();

    this.committeeService
      .loadCommitteesData()
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(committees => {
        this.committees = committees;
        this.selectedCommittees = committees?.filter(committee => {
          return committee.id && this.selectedIds.includes(committee.id);
        });
        this.cdr.markForCheck();
      });

    this.committeeService
      .loadCommitteesTreeData()
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(committeesTree => {
        this.committeesTree = committeesTree;
        this.cdr.markForCheck();
      });
  }

  onChangeActiveZone(value: boolean): void {
    // Нужен только для закрытия dropdown при нажатии вне ActiveZone. Для открытия dropdown используем onClickField()
    if (!value) {
      this.dropdownVisible = false;
    }

    this.cdr.markForCheck();
  }

  onClickField(): void {
    this.dropdownVisible = !this.dropdownVisible;
    this.cdr.markForCheck();
  }

  onChangeSelectedCommittee(selectedCommittees: CommitteeUI[]) {
    let committeeIds: string[] = [];
    selectedCommittees?.forEach(committee => {
      if (committee.id) committeeIds.push(committee.id);
    });
    committeeIds = this.filter(committeeIds, this.disableSelect);

    this.selectedIds = [...committeeIds];

    this.emitSelectedIdsChange(committeeIds);
  }

  filter(source: string[], excludes: string[] = []): string[] {
    return source.reduce((acc: string[], curr) => {
      if (!excludes.includes(curr)) {
        acc.push(curr);
      }
      return acc;
    }, []);
  }

  onChangeSelectedIds(committeeIds: string[]) {
    committeeIds = this.filter(committeeIds, this.disableSelect);

    this.selectedCommittees = [
      ...(this.committees?.filter(committee => committee.id && committeeIds.includes(committee.id)) || []),
    ];

    if (!this.multiple) {
      // Если выбор одиночный - закрываем dropdown при выборе значения
      this.dropdownVisible = false;
    }

    this.selectedIds = [...committeeIds];
    this.emitSelectedIdsChange(committeeIds);
  }

  readonly stringify: TuiStringHandler<any | TuiContext<any>> = item => {
    return 'name' in item ? item.name : item.$implicit.name;
  };

  private emitSelectedIdsChange(committeeIds: string[]) {
    this.selectedIdsChange.emit(committeeIds);
  }
}
